module.exports = __webpack_public_path__ + "static/Fabrik-Bold-04476107f57214e7daa9fd8034356bd4.woff2";